import { Component, Input, OnInit } from '@angular/core';
import { OperationsService, StorageService } from 'src/app/_services';


@Component({
  selector: 'app-duplicatechecker',
  templateUrl: './duplicatechecker.component.html',
  styleUrls: ['./duplicatechecker.component.css']
})
export class DuplicatecheckerComponent implements OnInit {

  @Input() disburse:any;
  status = 'loading';
  currentUser:any;
  constructor(public operationsService: OperationsService, public storageService: StorageService) {
    this.currentUser = this.storageService.read<any>('currentUser');
     
  }

  ngOnInit() {
    this.checkDisStatys(this.disburse);
  }
  checkDisStatys(disburse){
    this.operationsService.checkDisStatys(this.currentUser.token, disburse)
    .subscribe(result => {

      this.status = result.status
    });
  }
}
